import React from 'react'

import './index.scss'

export const Item = ({ title, category, selectCategory, count }) => (
  <li
    className="item"
    role="tab"
    aria-selected={category === title ? 'true' : 'false'}
  >
    <div onClick={() => selectCategory(title)}>
      {title}
      <span className="badge">{count}</span>
    </div>
  </li>
)
